/*!
 * liveOverflow.js — let the score show what the console put outside its page
 * © 2026 Rob Canning — GPLv3
 *
 * The score <svg> clips to its own box, and that box begins at the playhead:
 * at the start of a piece the whole left half of the screen is outside it.
 * Things the live console makes are placed by the screen, not by the page --
 * a shape at at:[0.3, 0.5], a synth's scope box centred on screen -- so
 * there they would be cut off, or not show at all. While any such thing
 * exists the score shows its overflow. That also shows whatever an author
 * parked off the page, so it goes back to clipping when the last one goes.
 */

const LIVE = ".oscilla-shape, #oscilla-live-audio-group > rect";

/**
 * Call after making or removing a live thing in `svg`. A score that shows
 * its overflow by itself (style="overflow:visible" on its <svg>, as a dark
 * stage reaching past the page does) keeps it when the last one goes.
 */
export function syncLiveOverflow(svg) {
  if (!svg?.style) return;
  if (svg.dataset.ownOverflow == null) svg.dataset.ownOverflow = svg.style.overflow || "";
  svg.style.overflow = svg.querySelector(LIVE) ? "visible" : svg.dataset.ownOverflow;
}
